import React from 'react';
import { IconArrowRightBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { getNameByFinancialCompanyCode, PAYMENT_METHOD_LABEL } from '@common/constants';
import { Typography } from '@common/styles';
import {
  FinancialCompanyCode,
  formatKoreanNumber,
  PaymentMethod,
  PaymentNotificationItemList,
} from '@domains/pdp-common';

interface Props {
  list: PaymentNotificationItemList[];
  onClick: (item: PaymentNotificationItemList) => void;
}

export const EventNotificationList = ({ list, onClick }: Props) => {
  const getCardName = (financial_company_code: FinancialCompanyCode | null, payment_method: PaymentMethod) => {
    if (financial_company_code) {
      return getNameByFinancialCompanyCode('ko', financial_company_code);
    } else {
      return PAYMENT_METHOD_LABEL[payment_method]['ko'];
    }
  };

  return (
    <List className={Typography.BODY_14_REGULAR}>
      {list.map((item) => {
        return item.payment_notification_content_list
          .filter((c) => c.language === 'ko' && !!c.content?.trim()?.length)
          .map(({ content }, index) => (
            <Item key={`${content}-${index}`} className={Typography.BODY_14_REGULAR} onClick={() => onClick(item)}>
              <div>
                {getCardName(item.financial_company_code, item.payment_method)} 최대{' '}
                <span>{formatKoreanNumber(item.discount_amount ?? 0)}</span> 할인
              </div>
              <IconArrowRightBold size={18} v3Color='gray500' />
            </Item>
          ));
      })}
    </List>
  );
};

const List = styled.div`
  position: relative;
  top: -1px;
  color: ${vars.color.textStrong};
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0 0 4px;
  border: none;
  word-break: keep-all;
  line-height: 140%;

  span {
    font-weight: 500;
  }
`;
